// extracted by mini-css-extract-plugin
export var equalColumn = "_fd-0";